// eslint-disable-next-line css-modules/no-unused-class
import { IonItem } from '@ionic/react';
import { FieldValuesType, FormValueType } from '../../hooks/useFormValues';
import { Checkbox } from './Checkbox';
// eslint-disable-next-line css-modules/no-unused-class
import styles from './FormFields.module.css';

type FormCheckboxParams<T> = {
	setValues: (value: FormValueType<T>) => void;
	id: string;
	field?: FieldValuesType<boolean>;
	label: string;
};

export function FormCheckbox<T>({ setValues, id, field, label }: FormCheckboxParams<T>) {
	return (
		<IonItem lines="none" className={styles.fieldContainer}>
			{field && (
				<Checkbox
					label={label}
					value={field.value}
					onClick={e => {
						setValues({
							[id]: e.target.checked
						} as FormValueType<T>);
					}}
				/>
			)}
		</IonItem>
	);
}
